import React, { useMemo } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps } from '../types'

export const MeshGradientEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1', '#8b5cf6', '#ec4899'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const color1 = effectColors[0] || '#6366f1'
  const color2 = effectColors[1] || '#8b5cf6'
  const color3 = effectColors[2] || '#ec4899'
  const color4 = effectColors[3] || '#14b8a6'

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      <motion.div
        style={{
          position: 'absolute',
          inset: 0,
          opacity: opacityValue,
          background: `
            radial-gradient(at 0% 0%, ${color1} 0px, transparent 50%),
            radial-gradient(at 100% 0%, ${color2} 0px, transparent 50%),
            radial-gradient(at 100% 100%, ${color3} 0px, transparent 50%),
            radial-gradient(at 0% 100%, ${color4} 0px, transparent 50%)
          `,
          filter: 'blur(100px)',
        }}
        animate={{
          scale: [1, 1.2, 1],
          rotate: [0, 5, 0],
        }}
        transition={{
          duration: 20 * (100 / Math.max(effectSpeed, 1)),
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
    </div>
  )
})
MeshGradientEffect.displayName = 'MeshGradientEffect'
